import { bottom } from '@popperjs/core'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {Footer} from './Footer'

const FooterWrapper = () => {
  const {config} = useLayout()
  if (!config.app?.footer?.display) {
    return null
  }

  return (
    <div  id='kt_app_footer' style={{position:"relative",left:"0",bottom:"0",width:"100%"}}>
      {config.app.footer.containerClass ? (
        <div className={clsx('app-container', config.app.footer.containerClass)}  style={{marginLeft:"10px",color: "#9E2A8D"}}>
          <Footer />
        </div>
      ) : (
        <Footer  />
      )}
    </div>
  )
}

export {FooterWrapper}
